export default __webpack_public_path__ + "static/media/bwin_fantasy_pick em_MPU_300x250.326b328a.png";